export const MAX_PRIORITY_FEE = 10_000;
export const COMPUTE_UNIT_LIMIT = 1_000_000;
export const COMPUTE_UNIT_LIMIT_MULTIPLIER = 1.1;
